import { ItemDisplayOptions as ItemDisplayOptionsDto, UserRole } from 'src/app/services/api.services';
import { RichTextValue } from '../RichTextValue';
import { AppUser } from 'src/app/shared/models/app-user';
import { isNullOrUndefined } from 'src/app/shared/utils';

export class ItemDisplayOptions {
  constructor(public readonly dto: ItemDisplayOptionsDto) { }

  get order() { return this.dto?.order ?? 0; }
  get hidden() { return this.dto?.hidden ?? false; }
  get minUserRole() { return this.dto?.minUserRole; }

  readonly description = RichTextValue.from(this.dto?.description);
  readonly tooltip = RichTextValue.from(this.dto?.tooltip);

  readonly selectorDisplayName = this.dto?.selectorDisplayName;

  isHiddenFor(user: { role: UserRole; }) {
    if (this.hidden)
      return true;

    if (!isNullOrUndefined(this.minUserRole))
      return user.role < this.minUserRole;

    return false;
  }
}

export namespace ItemDisplayOptions {
  export function sort<T extends { itemDisplay: ItemDisplayOptions; }>(
    items: T[],
    fallbackProperty?: (item: T) => any) {
    items.sort((a, b) => {
      let d = a.itemDisplay.order - b.itemDisplay.order;
      if (d == 0) {
        if (fallbackProperty) {
          let ap = fallbackProperty(a);
          let bp = fallbackProperty(b);
          if (typeof ap === 'string' || typeof bp === 'string')
            d = ('' + ap).localeCompare(('' + bp));
          else
            d = ((ap < bp) ? -1 : ((ap > bp) ? +1 : 0));
        }
      }

      return d;
    });
  }
}
